"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPluginArguments = exports.AddPluginOptions = void 0;
exports.AddPluginOptions = [
    {
        name: "api-plugin-type",
        type: "string",
        description: "API plugin type.",
        required: true,
        default: "new-api",
        choices: ["api-spec", "existing-plugin"],
    },
    {
        name: "plugin-manifest-path",
        type: "string",
        description: "Plugin manifest path.",
    },
    {
        name: "plugin-opeanapi-spec-path",
        type: "string",
        description: "OpenAPI description document used for your API plugin.",
    },
    {
        name: "openapi-spec-location",
        type: "string",
        shortName: "a",
        description: "OpenAPI description document location.",
    },
    {
        name: "api-operation",
        type: "array",
        shortName: "o",
        description: "Select operation(s) Copilot can interact with.",
    },
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specify the path for Teams app manifest template. It can be either absolute path or relative path to the project root folder, with default at './appPackage/manifest.json'",
        required: true,
        default: "./appPackage/manifest.json",
    },
];
exports.AddPluginArguments = [];
//# sourceMappingURL=AddPluginOptions.js.map